import TableStyles from '@Resources/styles/tables.scss';
import ColorsStyles from '@Styles/colors.scss';
import { SortOrder } from '@Utils/helpers/sortingHelpers';
import DescendingIcon from '@mui/icons-material/ArrowDropDown';
import AscendingIcon from '@mui/icons-material/ArrowDropUp';
import FailIcon from '@mui/icons-material/ClearOutlined';
import PassIcon from '@mui/icons-material/DoneOutlined';
import cx from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { IEntity } from '@Data/entities/Interfaces';
import { QualityControlApi } from '@Data/qualityControl/Api';
import {
    AnalysisEntityState,
    IAnalysisEntity,
    TableSortField,
} from '@Data/qualityControl/Interfaces';
import {
    analysisEntityTableSortFieldState,
    analysisEntityTableSortOrderState,
} from '@Data/qualityControl/Reducer';
import QcEnityMenu from './QcEnityMenu';
import Styles from './QcEntitiesTable.scss';

interface IQcEntitiesTable {
    data: IAnalysisEntity[];
    selectedEntity: IAnalysisEntity;
    onSetQcEntity: (d: any) => void;
    disableReworkReason?: boolean;
    selectedRowBackgroundColor?: string;
}

export const QcEntitiesTable = (props: IQcEntitiesTable) => {
    const { data, selectedEntity, onSetQcEntity } = props;

    const sortOrder = useSelector(analysisEntityTableSortOrderState);
    const sortField = useSelector(analysisEntityTableSortFieldState);

    const getStateIcon = (state: AnalysisEntityState) => {
        switch (state) {
            case AnalysisEntityState.PASS:
                return <PassIcon className={Styles.passIcon} />;
            case AnalysisEntityState.REWORK:
                return <FailIcon className={Styles.failIcon} />;
            case AnalysisEntityState.TODO:
                return null;
        }
    };

    const handleSortOrdering = (newField: TableSortField) => {
        let order = SortOrder.ASC;
        if (newField === sortField) {
            order =
                sortOrder === SortOrder.DESC ? SortOrder.ASC : SortOrder.DESC;
        }

        QualityControlApi.setTableSorting(newField, order);
    };

    const sortOrderIcon =
        sortOrder === SortOrder.DESC ? <DescendingIcon /> : <AscendingIcon />;

    const selectedRowColor =
        props.selectedRowBackgroundColor ?? ColorsStyles.ikeSecondaryDarkGreen;
    const selectedBtnColor = props.selectedRowBackgroundColor ? '#000' : null;

    return (
        <table className={Styles.qcEntitiesTable}>
            <thead>
                <tr>
                    <td
                        className={cx(
                            Styles.qcIds,
                            sortField === TableSortField.CLIENT_ID
                                ? TableStyles.selectedHeader
                                : ''
                        )}
                        onClick={() =>
                            handleSortOrdering(TableSortField.CLIENT_ID)
                        }
                    >
                        <div>
                            Pole Id
                            {sortField === TableSortField.CLIENT_ID && (
                                <React.Fragment>{sortOrderIcon}</React.Fragment>
                            )}
                        </div>
                    </td>
                    <td
                        className={cx(
                            Styles.qcIcons,
                            sortField === TableSortField.QC_STATE
                                ? TableStyles.selectedHeader
                                : ''
                        )}
                        onClick={() =>
                            handleSortOrdering(TableSortField.QC_STATE)
                        }
                    >
                        <div>
                            Result
                            {sortField === TableSortField.QC_STATE && (
                                <React.Fragment>{sortOrderIcon}</React.Fragment>
                            )}
                        </div>
                    </td>

                    <td className={Styles.qcIcons}></td>
                </tr>
            </thead>
            <tbody>
                {data.map((d) => {
                    const isSelected =
                        d.entity_version_id ===
                        selectedEntity?.entity_version_id;
                    return (
                        <tr
                            key={d.entity_version_id}
                            className={isSelected ? selectedRowColor : null}
                            onClick={() => onSetQcEntity(d)}
                            style={{
                                backgroundColor: isSelected
                                    ? selectedRowColor
                                    : null,
                            }}
                        >
                            <td className={Styles.qcIds}>{d.client_id}</td>
                            <td className={Styles.qcIcons}>
                                {getStateIcon(d.qcState)}
                            </td>

                            <td style={{ minWidth: '28px' }}>
                                {isSelected && (
                                    <QcEnityMenu
                                        entity={d}
                                        collection={
                                            selectedEntity.original_ike_office_uuid
                                        }
                                        selectedBackgroundColor={
                                            selectedRowColor
                                        }
                                        selectedBtnColor={selectedBtnColor}
                                    />
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
